// extracted by mini-css-extract-plugin
export default {"info":"CategoryCard_info__DXm2c"};